<template>
    <div id="detail">
        <transition name="fade">
            <Loading v-if="isLoading" />
        </transition>
        <goTop />
        <step :stepNumber="2"/>
        <div class="content">
            <div class="form">
                <div class="container" @change="saveApplicantData">
                    <h2 class="title2">填寫資料</h2>
                    <h3 class="blueTitle">要保人資料</h3>
                    <p class='attentionTxt'><img src='noticemark.svg' class='attention'>若您有調整要保人資料，將同步更新您的會員資料。</p>
                    <div class="oneline">
                        <label class="checkbox">
                            <input type="checkbox" v-model="applicantData.needEnglishPolicy" :disabled="needEnglishPolicyDisabled"/>
                            <div class="checkStyle"></div>
                            是否需要英文投保證明
                        </label>
                    </div>
                    <div class="inline">
                        <div class="inputControl">
                            <div class="inputTitle" :class="{ 'pinkText': check1 }">姓名</div>
                            <input type="text" class="inputStyle tlf_r_f1 clarity-mask" id="assuredName_Detail" v-model="applicantData.applicantName"
                                :class="{ 'alert': check1 }">
                        </div>
                        <div class="inputControl">
                            <div class="inputTitle" :class="{ 'pinkText': check2 }">手機號碼</div>
                            <input type="text" class="inputStyle tlf_n_l4 clarity-mask" id="assuredTel_Detail" v-model="applicantData.applicantMob"
                                :class="{ 'alert': check2 }">
                        </div>
                    </div>
                    <div class="oneline" v-if="applicantData.needEnglishPolicy">
                        <div class="inputControl">
                            <div class="inputTitle" :class="{ 'pinkText': check3 }">英文姓名</div>
                            <input type="text" class="inputStyle tlf_r_f1" id="assuredEnglishName_Detail" v-model="applicantData.applicantEngName"
                                :class="{ 'alert': check3 }">
                        </div>
                    </div>
                    <div class="inline">
                        <div class="inputControl">
                            <div class="inputTitle" :class="{ 'pinkText': check4 }">身分證 / 居留證</div>
                            <input type="text" class="inputStyle tlf_n_l5 clarity-mask" id="assuredIdNo_Detail" v-model="applicantData.applicantIdNo"
                                v-on:blur="checkIdType" :class="{ 'alert': check4 }" readonly>
                        </div>
                        <div class="inputControl">
                            <div class="inputTitle" :class="{ 'pinkText': check5 }">國籍</div>
                                <model-select :options="nationOptions"
                                              class="inputStyle arrow selectSearch clarity-mask"
                                              :class="{ 'alert': check5 }"
                                              v-model="applicantDataRiskCountry"
                                              placeholder="請選擇國籍"
                                >
                                </model-select>
                        </div>
                    </div>
                    <div class="oneline">
                        <div class="inputControl">
                            <div class="inputTitle" :class="{ 'pinkText': check6 }">電子郵件</div>
                            <input type="text" class="inputStyle tlf_n_at1 clarity-mask" id="assuredEmail_Detail" v-model="applicantData.applicantEmail"
                                :class="{ 'alert': check6 }">
                        </div>
                    </div>
                    <BirthdayChange :dateTimeProps="applicantData.applicantBirthday" @getDateTime="getApplicantBirthday"
                        :key="reloadYearChangeKey"  nickName="applicant" ref="yearRef"/>
                    <div class="oneline">
                        <div class="inputControl">
                            <div class="inputTitle">職/行業別</div>
                            <select name="" id="" class="inputStyle arrow clarity-mask" v-model="applicantData.applicantJob">
                                <option v-for="(job, index) in riskJobList" :value="job.jobCode" :key="index">{{ job.jobName }}</option>
                            </select>
                        </div>
                    </div>
                    <div class="inline">
                        <div class="inputControl">
                            <div class="inputTitle" :class="{ 'pinkText': check7 && check8 && check9 }">居住地址</div>
                            <select name="" id="" class="inputStyle arrow clarity-mask" v-model="applicantData.applicantAddrCity"
                                @change="getAddrZipList(null, null)" :class="{ 'alert': check7 }">
                                <option value="" selected disabled>縣市</option>
                                <option v-for="(city, index) in cityList" :value="city.id" :key="index">{{ city.cityName }}
                                </option>
                            </select>
                        </div>
                        <div class="inputControl">
                            <div class="inputTitle"></div>
                            <select class="inputStyle arrow clarity-mask" v-model="applicantData.applicantAddrZip"
                                :class="{ 'alert': check8 }">
                                <option value="" selected disabled>區域</option>
                                <option v-for="(zip, index) in zipList" :value="zip.id" :key="index">{{ zip.zipName }}
                                </option>
                            </select>
                        </div>
                    </div>
                    <div class="oneline">
                        <div class="inputControl">
                            <input type="text" name="" class="inputStyle tlf_r_f6 clarity-mask" id="assuredAddress_Detail" v-model="applicantData.applicantAddrs"
                                :class="{ 'alert': check9 }">
                        </div>
                    </div>

                </div>
                <insureTab
                    :applicantData="applicantData"
                    :startCheck="startCheck"
                    :key="reloadInsureTabKey"
                    @reloadInsureTab="reloadInsureTabKey++"
                    ref="insureTabRef"
                />
                <div class="policyArea container clarity-unmask" v-if="termsCheck">
                    <h3 class="blueTitle">同意聲明告知事項</h3>
                    <div class="policyDiv">
                        <div class="policyCon">
                            <h3 class="policyTitle active">個人資料告知事項</h3>
                            <h3 class="policyTitle">會員服務條款</h3>
                            <h3 class="policyTitle">網路投保注意及聲明事項</h3>
                            <h3 class="policyTitle">網路保險服務定型化契約</h3>
                            <div class="policyText" >
                                <div class="textCon" @scroll="onScroll">
                                    <div id="policy1" class="policySection" v-html="policy1"></div><!--個人資料告知事項-->
                                    <div id="policy2" class="policySection" v-html="policy2"></div><!--會員服務條款-->
                                    <div id="policy3" class="policySection" v-html="policy3"></div><!--網路投保注意及聲明事項-->
                                    <div id="policy4" class="policySection" v-html="policy4"></div><!--網路保險服務定型化契約-->
                                </div>
                            </div>
                        </div>
                        <p class="pinkText center pinkAlert">請滑動並詳閱條款所載完整內容</p>
                        <p class="attentionTxt"><img src="noticemark.svg" class="attention" alt=""> 本公司所蒐集之個人資料並無共同行銷或屬保險以外且具正當合理關聯之特定項目。</p>
                        <div class="policyCheck" @change="checkForm">
                            <label class="checkbox" :class="{ 'alert': check10 }" ><input type="checkbox" v-model="agreeExplain" disabled/>
                                <div class="checkStyle"></div>
                                我已閱讀並同意上述說明
                            </label>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="btnArea">
            <div class="anotherBtn">
                <router-link :to="'/adjustment'" class="btn detail_back_accu">返回</router-link>
                <div class="btn confirm detail_go_accu" @click="submitDetailPage">確定</div>
            </div>
        </div>
    </div>
</template>

<script setup>
        import goTop from "@/components/gotop.vue";
        import step from "@/components/step.vue";
        import insureTab from "@/components/detail/insureTab.vue";
        import BirthdayChange from "@/components/birthdayChange.vue";
        import LoadData from "@/utils/loadData";
        import CheckData from "@/utils/checkData";
        import moment from "moment";
        import { getApi, postApi } from "@/utils/callApi";
        import Loading from "@/components/loading.vue";
        import {ModelSelect}  from 'vue-search-select'
        import {popUp} from "@/utils/popUp";
        import {onMounted, ref, toRaw, watch} from "vue";
        import {useRouter} from "vue-router";
        import Swal from 'sweetalert2'
        import apiConfig from "@/utils/apiConfig";
        import $ from 'jquery'
        import gtm from "@/utils/gtmDataLayer";
        import checkData from "@/utils/checkData";

        const router = useRouter();

        let riskCountryList = [];//國籍清單
        let jwtInfo = {};
        let pageStorage = {};
        let detailStorage = {};//要被保人資料
        let loadComplete = false; //完整載入才能觸發 saveApplicantData
        let termsMemberList = {}; //整理後的條款資料

        const isLoading = ref(false);
        const applicantData = ref({
            applicantIdNo: '',
            applicantRiskCountry: '',
            applicantName: '',
            applicantEngName: '',
            applicantMob: '',
            applicantEmail: '',
            applicantBirthday: {},
            applicantJob: '000',
            applicantAddrCity: '',
            applicantAddrZip: '',
            applicantAddrs: '',
            needEnglishPolicy: false,
        });//要保人資料
        const applicantDataRiskCountry = ref("");
        const nationOptions = ref([]);//國籍清單(顯示用)
        const riskJobList = ref([]);//職業清單
        const cityList = ref([]);//城市清單
        const zipList = ref([]);//區域清單
        const reloadYearChangeKey = ref(0);//觸發 yearChange 重新載入
        const reloadInsureTabKey = ref(0);
        const insureTabRef = ref();
        const yearRef = ref();
        const startCheck = ref(false);//開始監聽欄位格式
        const needEnglishPolicyDisabled = ref(false);//英文投保證明鎖
        const check1 = ref(false) ;
        const check2 = ref(false) ;
        const check3 = ref(false) ;
        const check4 = ref(false) ;
        const check5 = ref(false) ;
        const check6 = ref(false) ;
        const check7 = ref(false) ;
        const check8 = ref(false) ;
        const check9 = ref(false) ;
        const check10 = ref(false) ;
        const idType = ref(true);//true:台灣人,false:外國人
        let termsCheck = true;
        const agreeExplain = ref(false);
        const termsMember =  ref([]);//CMS會員條款
        const termsMemberTravel = ref([]); //CMS會員條款for旅平險
        const policy1 = ref({});//個人資料告知事項
        const policy2 = ref({});//會員服務條款
        const policy3 = ref({});//CMS旅平險:網路投保注意及聲明事項
        const policy4 = ref({});//網路保險服務定型化契約
        const device = ref("");//使用者裝置
        const system = ref("");//作業系統;
        const browserName = ref("");//使用者瀏覽器

        //只有註冊頁進來的才不需要顯示條款
        if(JSON.parse(sessionStorage.getItem("termsCheck")) === false){
            termsCheck = false;
        }

        //載入國籍清單
        const getRiskCountryList = () => {
            LoadData.getRiskCountryList(function (data) {
                riskCountryList = data;
                if(applicantData.value.applicantIdNo.length > 0){
                    checkIdType();
                }
            });
        }
        //載入職行業清單
        const getRiskJobList = () =>{
            LoadData.getRiskJobList(function (data) {
                riskJobList.value = data;
            });
        }
        //載入縣市清單
        const getAddrCityList = (findCity, cityType, findZip, zipType) => {
            LoadData.getAddrCityList(function (data) {
                cityList.value = data;
                //查詢後進行預設
                if (findCity != null && findCity !== "") {
                    let cityObject;
                    switch (cityType) {
                        case "name":
                            cityObject = cityList.value.find(city => city.cityName === findCity);
                            break;
                        case "code":
                            cityObject = cityList.value.find(city => city.cityCode === findCity);
                            break;
                    }
                    applicantData.value.applicantAddrCity = cityObject.id;
                    getAddrZipList(findZip, zipType);
                }
            });
        }
        //載入區域清單
        const getAddrZipList = (findZip, zipType) => {
            if(applicantData.value.applicantAddrCity){
                var cityObject = cityList.value.find(city => city.id === applicantData.value.applicantAddrCity)
                LoadData.getAddrZipList(cityObject.cityCode, function (data) {
                    zipList.value = data;
                    applicantData.value.applicantAddrZip = "";
                    //查詢後進行預設
                    if (findZip != null && findZip !== "") {
                        var zipObject;
                        switch (zipType) {
                            case "name":
                                zipObject = zipList.value.find(zip => zip.zipName === findZip);
                                break;
                            case "code":
                                zipObject = zipList.value.find(zip => zip.zipCode === findZip);
                                break;
                            case "id":
                                zipObject = {id : findZip};
                        }
                        applicantData.value.applicantAddrZip = zipObject.id;
                        saveApplicantData();
                    }
                });
            }
        }

        //載入detailStorage
        const loadDetailStorage = () => {
            if (detailStorage != null) {
                if (detailStorage.applicantData != null) {
                    applicantData.value= detailStorage.applicantData;
                    if (applicantData.value.applicantIdNo !== '') {
                        checkIdType();
                    }
                    if (applicantData.value.applicantAddrCity !== '') {
                        getAddrZipList(applicantData.value.applicantAddrZip, "id");
                    }
                    applicantDataRiskCountry.value = applicantData.value.applicantRiskCountry;
                    reloadYearChangeKey.value += 1;
                    checkSchengenNeedEnglishPolicy();
                }

            }
            loadComplete = true;
        }

        //確認登入
        const checkLogin = () => {
            if (jwtInfo != null) {
                isLoading.value = true;
                getApi(apiConfig.userApiGet, jwtInfo.token)
                    .then((response) => {
                        var userApiGetRes = response.data;
                        if (userApiGetRes.code === 200) {
                            var userData = userApiGetRes.data;
                            //首次帶入資料
                            if (detailStorage == null) {
                                applicantData.value.applicantName = userData.applicantName;
                                applicantData.value.applicantMob = userData.applicantMobile;
                                applicantData.value.applicantIdNo = userData.applicantIdNo;
                                applicantData.value.applicantEmail = userData.applicantEmail;
                                applicantData.value.applicantAddrs = userData.applicantAddress;
                                //查詢縣市進行預設,查詢區域行預設
                                getAddrCityList(userData.applicantCityName, "name", userData.applicantZipName, "name");
                                //檢查格式
                                if(!checkData.email(userData.applicantEmail)){  //驗證email格式是否正確，強迫修改會員資料
                                    Swal.fire({
                                        title: "請更新您的電子信箱",
                                        showConfirmButton: true,
                                        showCancelButton: false,
                                        confirmButtonText: '更新會員資料',
                                        html: '<img src="error.svg">' +
                                            '<p>親愛的客戶您好，您先前投保所使用之電子信箱，經查證屬實係為他人所有擁有。經透過手機號碼未能與您取得聯繫，為避免造成原電子信箱用戶困擾，已將您的電子信箱進行刪除。</p>'+
                                            '<p>為維護您的會員權益，<span class="red">請立即前往會員專區更新您的電子信箱</span>。通過驗證後，即可進行投保，感謝您的配合。</p>',
                                    }).then(function () {
                                        window.location.href = process.env.VUE_APP_DOMAIN+process.env.VUE_APP_MEMBER + "memberInfo";
                                        isLoading.value = true
                                    });
                                    isLoading.value = false
                                }else if(!checkData.mobile(userData.applicantMobile)  || userData.applicantMobile==="0900000000"){ //驗證手機號碼格式是否正確，強迫修改會員資料
                                    Swal.fire({
                                        title: "請更新您的手機號碼",
                                        showConfirmButton: true,
                                        showCancelButton: false,
                                        confirmButtonText: '更新會員資料',
                                        html: '<img src="error.svg">' +
                                            '<p>親愛的客戶您好，您先前投保所使用之手機號碼，經查證屬實係為他人所有擁有。經透過電子郵件未能與您取得聯繫，為避免造成原手機號碼用戶困擾，已將您的手機號碼進行刪除。</p>'+
                                            '<p>為維護您的會員權益，<span class="red">請立即前往會員專區更新您的手機號碼</span>。通過驗證後，即可進行投保，感謝您的配合。</p>',
                                    }).then(function () {
                                        window.location.href = process.env.VUE_APP_DOMAIN+process.env.VUE_APP_MEMBER + "memberInfo";
                                        isLoading.value = true
                                    });
                                    isLoading.value = false
                                }

                                //進行生日預設
                                if(userData.applicantBirthday){
                                    const birthday = moment(userData.applicantBirthday);
                                    applicantData.value.applicantBirthday = {
                                        year: birthday.year(),
                                        month: birthday.month() + 1,
                                        date: birthday.date(),
                                    }
                                    reloadYearChangeKey.value += 1;
                                }
                                checkSchengenNeedEnglishPolicy();
                                checkIdType();
                            }
                        } else {
                            Swal.fire({
                                title: "資料錯誤",
                                showConfirmButton: false,
                                showCloseButton: true,
                                html: '<img src="error.svg"><p>'+ userApiGetRes.message + '</p>',
                            });
                        }
                        isLoading.value = false;
                    }).catch((error) => {
                    Swal.fire({
                        title: "資料錯誤",
                        showConfirmButton: false,
                        showCloseButton: true,
                        html: '<img src="error.svg"><p>取得會員資料錯誤</p>',
                    });
                    isLoading.value = false;
                });
            } else {
                Swal.fire({
                    title: "逾期使用",
                    confirmButtonText: "確定",
                    showCloseButton: true,
                    html: '<img src="error.svg"><p>您已經被登出</p>',
                }).then(() => {
                    router.push('/');
                });
            }
        }

        //從child components取得生日
        const getApplicantBirthday = (data) => {
            applicantData.value.applicantBirthday = data;
            saveApplicantData();
        }
        //若有申根國家且傷害醫療150萬預設英文投保證明勾起
        const checkSchengenNeedEnglishPolicy = () =>{
            //若有申根國家且傷害醫療150萬預設英文投保證明勾起
            if(pageStorage.haveSchengenFlag && pageStorage.harmMedicalAmount >= 120){
               applicantData.value.needEnglishPolicy = true;
                needEnglishPolicyDisabled.value = true;
            }
        }
        //檢查ID類型
        const  checkIdType = () => {
            var checkIdType = CheckData.id(applicantData.value.applicantIdNo);
            if (checkIdType === 'resident') {
                if (applicantDataRiskCountry.value === "台灣(Taiwan)") {
                    applicantDataRiskCountry.value = "";
                }
                if(nationOptions.value.length !== riskCountryList.length) {
                    nationOptions.value = [];
                    if(riskCountryList.length !== 0) {
                        riskCountryList.forEach(rc => {
                            nationOptions.value.push({
                                value: rc.riskCountryName,
                                text: rc.riskCountryName
                            });
                        });
                    }
                }
            } else {
                idType.value = true;
                nationOptions.value = [];
                nationOptions.value.push({
                    value: "台灣(Taiwan)",
                    text: "台灣(Taiwan)"
                });
                applicantDataRiskCountry.value = "台灣(Taiwan)";

            }
            saveApplicantData();
        }
        //更動資料儲存至 sessionStorage
        const saveApplicantData = () => {
            detailStorage = JSON.parse(sessionStorage.getItem("detailStorage"));
            if(detailStorage && loadComplete){
                detailStorage.applicantData = toRaw(applicantData.value);
            }
            sessionStorage.setItem("detailStorage", JSON.stringify(detailStorage));
            checkForm();
        }
        //檢核要保人資料
        const checkForm = () =>{
            if(startCheck.value){
                if (applicantData.value != null) {
                    //姓名檢核
                    if (applicantData.value.applicantName === "") {
                        check1.value = true;
                    } else {
                        check1.value = false;
                    }
                    if (!CheckData.name(applicantData.value.applicantName)) {
                        check1.value = true;
                    } else {
                        check1.value = false;
                    }
                    //手機檢核
                    if (!CheckData.mobile(applicantData.value.applicantMob)) {
                        check2.value = true;
                    } else {
                        check2.value = false;
                    }
                    //英文姓名檢核
                    if (applicantData.value.needEnglishPolicy) {
                         if (applicantData.value.applicantEngName === "") {
                             check3.value = true;
                         }else{
                             check3.value = false;
                         }

                        if (!CheckData.englishName(applicantData.value.applicantEngName)) {
                            check3.value = true;
                        } else {
                            check3.value = false;
                        }

                    }

                    //身分證檢核
                    if (!CheckData.id(applicantData.value.applicantIdNo)) {
                        check4.value = true;
                    } else {
                        check4.value = false;
                    }
                    //國籍檢核
                    if (applicantData.value.applicantRiskCountry === "" || applicantData.value.applicantRiskCountry == null) {
                        check5.value = true;
                    } else {
                        check5.value = false;
                    }
                    //EMAIL檢核
                    if (!CheckData.email(applicantData.value.applicantEmail)) {
                        check6.value = true;
                    } else {
                        check6.value = false;
                    }

                    //地址檢核
                    if (applicantData.value.applicantAddrCity === ""
                        || applicantData.value.applicantAddrZip === ""
                        || applicantData.value.applicantAddrs === ""
                        || !CheckData.address(applicantData.value.applicantAddrs)) {
                        check7.value = true;
                        check8.value = true;
                        check9.value = true;
                    } else {
                        check7.value = false;
                        check8.value = false;
                        check9.value = false;
                    }
                }
                if(termsCheck){//如果是登入頁進來要檢核下拉條款
                    if(!agreeExplain.value){
                        check10.value = true;
                    }else{
                        check10.value= false;
                    }
                }
                $(".alert").parent().append("<p></p>");
            }
        }
        //Detail資料傳送
        const submitDetailPage = ()=> {
            startCheck.value = true;
            let checkFlag = 0;
            const errorMsg = [];
            //抓取最新Storage
            pageStorage = JSON.parse(sessionStorage.getItem("pageStorage"));
            detailStorage = JSON.parse(sessionStorage.getItem("detailStorage"));

            //檢核要保人資料
            checkForm();

            //觸發 insure_detail checkInsureForm();
            insureTabRef.value?.checkInsureForm();

            //觸發 yearChange checkForm();
            yearRef.value?.checkForm(true);


            //檢核要保人資料
            const applicantData = detailStorage.applicantData;
            if (applicantData != null) {
                //姓名檢核
                if (applicantData.applicantName === "") {
                    check1.value = true;
                    checkFlag++;
                    errorMsg.push("要保人姓名填寫錯誤");
                } else {
                    check1.value = false;
                }
                if (!CheckData.name(applicantData.applicantName)) {
                    check1.value = true;
                    checkFlag++;
                    errorMsg.push("要保人姓名請填寫中文2~50字以內/英文200字以內，中英文一起填寫300字以內，姓名之間不能有數字，請重新輸入");
                } else {
                    check1.value = false;
                }
                //手機檢核
                if (!CheckData.mobile(applicantData.applicantMob)) {
                    check2.value = true;
                    checkFlag++;
                    errorMsg.push("要保人手機號碼填寫錯誤");
                } else {
                    check2.value = false;
                }
                //英文姓名檢核
                if (applicantData.needEnglishPolicy) {
                    if (applicantData.applicantEngName === "") {
                        check3.value = true;
                        checkFlag++;
                        errorMsg.push("要保人英文姓名填寫錯誤");
                    } else {
                        check3.value = false;
                    }

                    if(!CheckData.englishName(applicantData.applicantEngName)){
                        check3.value = true;
                        checkFlag++;
                        errorMsg.push("要保人英文姓名填寫錯誤");
                    }else{
                        check3.value = false;
                    }
                }
                //身分證檢核
                if (!CheckData.id(applicantData.applicantIdNo)) {
                    check4.value = true;
                    checkFlag++;
                    errorMsg.push("要保人身分證填寫錯誤");
                } else {
                    check4.value = false;
                }
                //國籍檢核
                if (applicantData.applicantRiskCountry === "") {
                    check5.value = true;
                    checkFlag++;
                    errorMsg.push("要保人請選擇國籍");
                } else {
                    check5.value = false;
                }
                //EMAIL檢核
                if (!CheckData.email(applicantData.applicantEmail)) {
                    check6.value = true;
                    checkFlag++;
                    errorMsg.push("要保人Email填寫錯誤");
                } else {
                    check6.value = false;
                }
                //生日檢核
                if (JSON.stringify(applicantData.applicantBirthday) === "{}") {
                    checkFlag++;
                    errorMsg.push("要保人生日填寫錯誤");
                } else {
                    if (applicantData.applicantBirthday.year === "" || applicantData.applicantBirthday.year == null
                        || applicantData.applicantBirthday.month === "" || applicantData.applicantBirthday.month == null
                        || applicantData.applicantBirthday.date === "" || applicantData.applicantBirthday.date == null) {
                        checkFlag++;
                        errorMsg.push("要保人生日填寫錯誤");
                    }
                }
                //地址檢核
                if (applicantData.applicantAddrCity === ""
                    || applicantData.applicantAddrZip === ""
                    || applicantData.applicantAddrs === ""
                    || !CheckData.address(applicantData.applicantAddrs)) {
                    check7.value = true;
                    check8.value = true;
                    check9.value = true;
                    checkFlag++;
                    errorMsg.push("要保人居住地址填寫錯誤");
                } else {
                    check7.value = false;
                    check8.value = false;
                    check9.value = false;
                }
            } else {
                checkFlag++;
                errorMsg.push("請填寫要保人資料");
            }

            //檢核被保人資料
            let haveOtherRelation = false;
            let haveSelfRelation = false;
            let haveSelfCount = 0;
            let insureIdNoList = [];
            const insureData = detailStorage.insureData;
            insureData.forEach((insure, insureKey) => {
                insureIdNoList.push(insure.insureIdNo);
                var user = "被保人 " + pageStorage.adjustData[insureKey].user
                if (JSON.stringify(insure) !== "{}") {
                    if (insure.insureName === "") {
                        checkFlag++;
                        errorMsg.push(user + " 姓名填寫錯誤");
                    }
                    if (!CheckData.name(insure.insureName)) {
                        checkFlag++;
                        errorMsg.push(user + " 姓名請填寫中文2~50字以內/英文200字以內，中英文一起填寫300字以內，姓名之間不能有數字，請重新輸入");
                    }
                    if (applicantData.needEnglishPolicy) {
                        if (insure.insuredEngName === "") {
                            checkFlag++;
                            errorMsg.push(user + " 英文姓名填寫錯誤");
                        }
                        if (!CheckData.englishName(insure.insuredEngName)) {
                            checkFlag++;
                            errorMsg.push(user + " 英文姓名填寫錯誤");
                        }
                        if (insure.passportNo === "") {
                            checkFlag++;
                            errorMsg.push(user + " 護照號碼填寫錯誤");
                        }
                    }
                    var insureIdType = CheckData.id(insure.insureIdNo)
                    if (!insureIdType) {
                        checkFlag++;
                        errorMsg.push(user + " 身分證填寫錯誤");
                    }
                    if (insureIdType === 'resident') {
                        if (insure.residentIssueDate === "") {
                            checkFlag++;
                            errorMsg.push(user + " 居留證核發日期填寫錯誤");
                        }
                        if (!insure.isPermanentResident && insure.residentPeriodDate === "") {
                            checkFlag++;
                            errorMsg.push(user + " 居留證期限/有效日期填寫錯誤");
                        }
                        if (insure.residentBackSn === "") {
                            checkFlag++;
                            errorMsg.push(user + " 居留證背面序號填寫錯誤");
                        }
                    }
                    if (insure.insureRiskCountry === "") {
                        checkFlag++;
                        errorMsg.push(user + " 請選擇國籍");
                    }
                    if (JSON.stringify(insure.insureBirthday) === "{}") {
                        checkFlag++;
                        errorMsg.push(user + " 生日填寫錯誤");
                    } else {
                        if (insure.insureBirthday.year === "" || insure.insureBirthday.year == null
                            || insure.insureBirthday.month === "" || insure.insureBirthday.month == null
                            || insure.insureBirthday.date === "" || insure.insureBirthday.date == null) {
                            checkFlag++;
                            errorMsg.push(user + " 生日填寫錯誤");
                        }
                    }
                    if (insure.insureAddrCity === ""
                        || insure.insureAddrZip === ""
                        || insure.insureAddrs === ""
                        || !CheckData.address(insure.insureAddrs)) {
                        checkFlag++;
                        errorMsg.push(user + " 居住地址填寫錯誤");
                    }
                    if (insure.insureRelation === "") {
                        checkFlag++;
                        errorMsg.push(user + " 請選擇與要保人關係");
                    }

                    if (insure.insureRelation === "OTHER"){
                        haveOtherRelation = true;
                    }
                    if(insure.insureRelation === "SELF"){
                        haveSelfRelation = true;
                        haveSelfCount++;
                    }

                    if (insure.beneficiaryType === "2") {
                        const beneficiaryArray = insure.beneficiaryArray;
                        if (beneficiaryArray.length < 1) {
                            checkFlag++;
                            errorMsg.push(user + " 至少一位受益人");
                        } else {
                            const beneficiaryIdNoList = [];
                            //檢查受益人
                            beneficiaryArray.forEach((beneficiary, beneficiaryKey) => {
                                beneficiaryIdNoList.push(beneficiary.beneficiaryIdNo);

                                var beneficiaryUser = user + " 之 受益人" + (beneficiaryKey + 1);
                                if (JSON.stringify(beneficiary) !== "{}") {
                                    if (beneficiary.beneficiaryName === "") {
                                        checkFlag++;
                                        errorMsg.push(beneficiaryUser + " 姓名填寫錯誤");
                                    }
                                    if (!CheckData.name(beneficiary.beneficiaryName)) {
                                        checkFlag++;
                                        errorMsg.push(beneficiaryUser + " 姓名請填寫中文2~50字以內/英文200字以內，中英文一起填寫300字以內，姓名之間不能有數字，請重新輸入");
                                    }
                                    if (!CheckData.id(beneficiary.beneficiaryIdNo)) {
                                        checkFlag++;
                                        errorMsg.push(beneficiaryUser + " 身分證填寫錯誤");
                                    }
                                    if (JSON.stringify(beneficiary.beneficiaryBirthday) === "{}") {
                                        checkFlag++;
                                        errorMsg.push(beneficiaryUser + " 生日填寫錯誤");
                                    } else {
                                        if (beneficiary.beneficiaryBirthday.year === ""
                                            || beneficiary.beneficiaryBirthday.month === ""
                                            || beneficiary.beneficiaryBirthday.date === "") {
                                            checkFlag++;
                                            errorMsg.push(beneficiaryUser + " 生日填寫錯誤");
                                        }
                                    }
                                    if (beneficiary.beneficiaryRiskCountry === "") {
                                        checkFlag++;
                                        errorMsg.push(beneficiaryUser + " 請選擇國籍");
                                    }
                                    if (!CheckData.mobile(beneficiary.beneficiaryMob)) {
                                        checkFlag++;
                                        errorMsg.push(beneficiaryUser + "手機號碼填寫錯誤");
                                    }
                                    if (beneficiary.beneficiaryAddrCity === ""
                                        || beneficiary.beneficiaryAddrZip === ""
                                        || beneficiary.beneficiaryAddrs === ""
                                        || !CheckData.address(beneficiary.beneficiaryAddrs)) {
                                        checkFlag++;
                                        errorMsg.push(beneficiaryUser + " 居住地址填寫錯誤");
                                    }
                                    if (beneficiary.beneficiaryRelation === "") {
                                        checkFlag++;
                                        errorMsg.push(beneficiaryUser + " 請選擇與被保人關係");
                                    }
                                    if (beneficiary.beneficiaryRelation === "SIBLING" && beneficiary.beneficiaryNotes === "") {
                                        checkFlag++;
                                        errorMsg.push(beneficiaryUser + " 請選擇受益人為兄弟姊妹的原因");
                                    }

                                } else {
                                    checkFlag++;
                                    errorMsg.push("請填寫" + beneficiaryUser + " 資料");
                                }
                            });
                            //檢核受益人身分證重複
                            const repeat = beneficiaryIdNoList.filter(function (element, index, arr) {
                                return arr.indexOf(element) !== index;
                            });
                            if(repeat.length > 0){
                                checkFlag++;
                                errorMsg.push(user + "受益人身分證重複" + repeat);
                            }

                        }
                    }
                } else {
                    checkFlag++;
                    errorMsg.push("請填寫 " + user + " 資料");
                }
            });

            //其他關係旅客檢核
            if(haveOtherRelation){
                if(!haveSelfRelation){
                    checkFlag++;
                    errorMsg.push("被保險人與要保人關係為【其他】時，旅客中需有一位為要保人。");
                }
            }

            //檢核是否多位本人
            if(haveSelfCount > 1){
                checkFlag++;
                errorMsg.push("被保險人僅能一位本人");
            }

            //檢核被保人身分證重複
            const repeat = insureIdNoList.filter(function (element, index, arr) {
                return arr.indexOf(element) !== index;
            });
            if(repeat.length > 0){
                checkFlag++;
                errorMsg.push("被保險人身分證重複" + repeat);
            }
            if(termsCheck){
                //同意聲明事項檢核
                if(!agreeExplain.value){
                    checkFlag++;
                    errorMsg.push('請確認並勾選同意聲明告知事項');
                    check10.value = true;
                }else{
                    check10.value = false;
                }
            }

            //確認檢核結果
            if (checkFlag === 0) {
                //組合POST參數
                //保單資料
                isLoading.value = true;
                const effDateTime = moment(pageStorage.startDate).format("YYYY-MM-DD") + ' ' + pageStorage.effTime + ':00';
                const expDateTime = moment(pageStorage.endDate).format("YYYY-MM-DD") + ' ' + pageStorage.effTime + ':00';
                const referrerCode = pageStorage.referrerCode;
                const planCode = pageStorage.mainPlan.planCode;
                const destinationList = [];
                //要保人資料
                const insTraOrderId = sessionStorage.getItem("insTraOrderId") ? sessionStorage.getItem("insTraOrderId") : "";
                const needEnglishPolicy = applicantData.needEnglishPolicy;
                const applicantName = applicantData.applicantName;
                const applicantEnglishName = applicantData.applicantEngName;
                const applicantBirthday = applicantData.applicantBirthday.year + "-" + applicantData.applicantBirthday.month + "-" + applicantData.applicantBirthday.date;
                const applicantIdNo = applicantData.applicantIdNo;
                const applicantNation = applicantData.applicantRiskCountry;
                const applicantMobile = applicantData.applicantMob;
                const applicantEmail = applicantData.applicantEmail;
                const applicantCityCode = applicantData.applicantAddrCity;
                const applicantZipCode = applicantData.applicantAddrZip;
                const applicantAddress = applicantData.applicantAddrs;
                const applicantIoccup = applicantData.applicantJob;
                const clientInfo = device.value + ',' + system.value + ',' + browserName.value + ' | UserAgent:' +navigator.userAgent;

                //被保人資料
                const rosterList = pageStorage.rosters;
                rosterList.forEach((roster, index) => {
                    const insureObject = insureData[index];
                    roster.insuredName = insureObject.insureName;
                    roster.insuredEngName = insureObject.insuredEngName;
                    roster.passportNo = insureObject.passportNo;
                    roster.insuredBirthday = insureObject.insureBirthday.year + "-" + insureObject.insureBirthday.month + "-" + insureObject.insureBirthday.date;
                    roster.insuredNation = insureObject.insureRiskCountry;
                    roster.insuredIdNo = insureObject.insureIdNo;
                    roster.insuredIoccup = insureObject.insureJob;
                    roster.insuredCityCodeId = insureObject.insureAddrCity;
                    roster.insuredZipCodeId = insureObject.insureAddrZip;
                    roster.insuredAddress = insureObject.insureAddrs;
                    roster.insuredRelation = insureObject.insureRelation;
                    roster.beneficiaryType = insureObject.beneficiaryType;
                    if (CheckData.id(insureObject.insureIdNo) === "resident") {
                        roster.residentBackSn = insureObject.residentBackSn;
                        roster.residentIssueDate = moment(insureObject.residentIssueDate.startDate).format("YYYY-MM-DD");
                        if(!insureObject.isPermanentResident){
                            roster.residentPeriodDate = moment(insureObject.residentPeriodDate.startDate).format("YYYY-MM-DD");
                            roster.permanentResidence = false;
                        }else{
                            roster.residentPeriodDate = null;
                            roster.permanentResidence = true;
                        }

                    }

                    if (insureObject.beneficiaryType === "2") {
                        roster.beneficiaryShare = insureObject.beneficiaryShareType;

                        //受益人資料
                        const beneficiaryList = [];
                        insureObject.beneficiaryArray.forEach((beneficiary) => {
                            const beneficiaryObject = {
                                beneficiaryName: beneficiary.beneficiaryName,
                                beneficiaryIdNo: beneficiary.beneficiaryIdNo,
                                beneficiaryBirthday: beneficiary.beneficiaryBirthday.year + "-" + beneficiary.beneficiaryBirthday.month + "-" + beneficiary.beneficiaryBirthday.date,
                                beneficiaryNation: beneficiary.beneficiaryRiskCountry,
                                beneficiaryMobile: beneficiary.beneficiaryMob,
                                beneficiaryCityCodeId: beneficiary.beneficiaryAddrCity,
                                beneficiaryZipCodeId: beneficiary.beneficiaryAddrZip,
                                beneficiaryAddress: beneficiary.beneficiaryAddrs,
                                beneficiaryRelation: beneficiary.beneficiaryRelation,
                                beneficiaryNotes: beneficiary.beneficiaryNotes,
                            };
                            beneficiaryList.push(beneficiaryObject);
                        });
                        roster.beneficiaryList = beneficiaryList;
                    }
                });

                // RND-169 國內旅平險成立訂單時將clarity資訊寫入訂單 2025.01.17 HansHuang
                const fpcInfo = JSON.parse(sessionStorage.getItem("fpcInfo"));
                const data = {
                    'travelArea': "A",
                    'effDateTime': effDateTime,
                    'expDateTime': expDateTime,
                    'needEnglishPolicy': needEnglishPolicy,
                    'referrerCode': referrerCode,
                    'insTraOrderId': insTraOrderId,
                    'applicantName': applicantName,
                    'applicantBirthday': applicantBirthday,
                    'applicantIdNo': applicantIdNo,
                    'applicantEnglishName': applicantEnglishName,
                    'applicantNation': applicantNation,
                    ['applicant' + 'Mobile']: applicantMobile,
                    'applicantEmail': applicantEmail,
                    'applicantCityCodeId': applicantCityCode,
                    'applicantZipCodeId': applicantZipCode,
                    ['applicant' + 'Address']: applicantAddress,
                    'applicantIoccup': applicantIoccup,
                    'destinationList': destinationList,
                    'rosterList': rosterList,
                    'planCode': planCode,
                    'clientInfo':clientInfo,
                };
                if (fpcInfo) {
                    data.clarityId = fpcInfo.clarityId;
                    data.sessionId = fpcInfo.sessionId;
                    data.fpc = fpcInfo.fpc;
                }

                jwtInfo = JSON.parse(localStorage.getItem("jwtInfo"));
                if (jwtInfo != null) {
                    checkInsuredBirthday(jwtInfo.token, data);
                } else {
                    Swal.fire({
                        title: "尚未登入",
                        confirmButtonText: "確定",
                        showCloseButton: true,
                        html: '<img src="error.svg" alt="error"><p>請進行登入後繼續</p>',
                    }).then(() => {
                        router.push('/login');
                    });
                    isLoading.value = false;
                }
            } else {
                Swal.fire({
                    title: "填寫資料錯誤",
                    showConfirmButton: false,
                    showCloseButton: true,
                    html: '<img src="error.svg" alt="error"><p>'+ errorMsg[0] + '</p>',
                }).then(function () {
                    $(".alert").parent().append("<p></p>");
                })
                isLoading.value = false;
            }
            if(applicantData.applicantBirthday !== null){
                const fpcInfo = JSON.parse(sessionStorage.getItem("fpcInfo"));
                postApi(apiConfig.event, null, null, null,{
                    tagName: "(新保)保費資料頁_要保人生日",
                    tagValue:applicantData.applicantBirthday.year + "-" + applicantData.applicantBirthday.month + "-" + applicantData.applicantBirthday.date,
                    sessionId: fpcInfo.sessionId,
                    fpc: fpcInfo.fpc,
                    clarityId: fpcInfo.clarityId,
                    insuranceType: "旅平險",
                })
            }
            if(applicantData.applicantIdNo !== null){
                const fpcInfo = JSON.parse(sessionStorage.getItem("fpcInfo"));
                postApi(apiConfig.event, null, null, null,{
                    tagName: "(新保)保費資料頁_要保人身分證字號",
                    tagValue:applicantData.applicantIdNo,
                    sessionId: fpcInfo.sessionId,
                    fpc: fpcInfo.fpc,
                    clarityId: fpcInfo.clarityId,
                    insuranceType: "旅平險",
                })
            }
        }

        const checkInsuredBirthday = (token, data) => {
            postApi(apiConfig.checkInsuredBirthday, token, null, null, data)
                .then((response) => {
                    var checkInsuredBirthdayRes = response.data;
                    if(checkInsuredBirthdayRes.code === 200) {
                        checkDetailPage(token, data);
                    }else if(checkInsuredBirthdayRes.code === 300){
                        Swal.fire({
                            title: "填寫資料確認",
                            showConfirmButton: true,
                            showCloseButton: true,
                            showCancelButton: true,
                            confirmButtonText: '正確',
                            cancelButtonText: '不正確重填',
                            reverseButtons: true,
                            html: '<img src="infomark.svg" alt="info"><p>'+ checkInsuredBirthdayRes.message + '</p>',
                        }).then((result) => {
                            if (result.isConfirmed) {
                                checkDetailPage(token, data);
                            }
                        });
                        isLoading.value = false;
                    }else{
                        Swal.fire({
                            title: "填寫資料錯誤",
                            showConfirmButton: false,
                            showCloseButton: true,
                            html: '<img src="error.svg" alt="error"><p>'+ checkInsuredBirthdayRes.message + '</p>',
                        });
                        isLoading.value = false;
                    }
                }).catch(() => {
                Swal.fire({
                    title: "資料錯誤",
                    showConfirmButton: false,
                    showCloseButton: true,
                    html: '<img src="error.svg" alt="error"><p>檢查資料連線錯誤</p>'
                });
                isLoading.value = false;
            });
        }

        const checkDetailPage = (token, data) =>{
           isLoading.value = true;
            postApi(apiConfig.checkDetailPage, token, null, null, data)
                .then((response) => {
                    var checkDetailRes = response.data;
                    if (checkDetailRes.code === 200) {
                        sessionStorage.setItem("insTraOrderId", checkDetailRes.data.insTraOrderId);
                        //觸發 insure_detail addInsureTraveler();
                        insureTabRef.value?.addInsureTraveler();

                        if(termsCheck){
                            termsUpdate();
                        }
                        if (checkDetailRes.data.policyType === "APPLY") {
                            popupApplyAlert();
                            isLoading.value = false;
                        } else {
                            isLoading.value = false;
                            router.push("/inform");
                        }
                    } else if(checkDetailRes.code === 600){
                        sessionStorage.setItem("insTraOrderId", checkDetailRes.data.insTraOrderId);
                        Swal.fire({
                            title: "填寫資料錯誤",
                            showConfirmButton: false,
                            showCloseButton: true,
                            html: '<img src="error.svg" alt="error"><p>'+ checkDetailRes.data.orderErrorMsg + '</p>',
                        });
                        isLoading.value = false;
                    } else {
                        Swal.fire({
                            title: "填寫資料錯誤",
                            showConfirmButton: false,
                            showCloseButton: true,
                            html: '<img src="error.svg" alt="error"><p>'+ checkDetailRes.message + '</p>',
                        });
                        isLoading.value = false;
                    }
                }).catch(() => {
                Swal.fire({
                    title: "資料錯誤",
                    showConfirmButton: false,
                    showCloseButton: true,
                    html: '<img src="error.svg" alt="error"><p>檢查資料連線錯誤</p>'
                });
               isLoading.value = false;
            });
        }

        const onScroll = ({ target: { scrollTop, clientHeight, scrollHeight } }) => {
            var $Div1 = document.getElementById('policy1').clientHeight
            var $Div2 = document.getElementById('policy2').clientHeight
            var $Div3 = document.getElementById('policy3').clientHeight
            if (scrollTop >= $Div1) {
                $(".policyCon").find('h3').eq(1).addClass('active');
            }
            if (scrollTop >= $Div1 + $Div2) {
                $(".policyCon").find('h3').eq(2).addClass('active');
            }
            if (scrollTop >= $Div1 + $Div2 + $Div3) {
                $(".policyCon").find('h3').eq(3).addClass('active');
            }
            if (scrollTop + clientHeight >= scrollHeight - 100) {
                $(".policyCheck").addClass("active").find("input[type='checkbox']").prop("disabled", false);
            }
        }
        //條款瀏覽版控
        const termsUpdate = () =>{
            var termsData = {
                source: '/ec/travel/taiwan',
                terms: termsMemberList
            }
            postApi(apiConfig.updateMemberTerms, jwtInfo.token, null, null, termsData)
                .then(() => {
                })
        }

        const getTermsMember = () =>{
            var data = {
                "Term":[
                    {
                        "insCategory":"Common",
                        "NoteType":[
                            1,2,3
                        ]
                    }
                ]
            }
            postApi(apiConfig.CMSDomain , null, null, null, data)
                .then((response) => {
                    if (response.data.Code === 200) {
                        termsMember.value = response.data.Data;
                        //取得個條款內容
                        policy1.value = termsMember.value.find(terms => terms.NoteType === 2).Content;
                        policy2.value = termsMember.value.find(terms => terms.NoteType === 1).Content;
                        policy4.value = termsMember.value.find(terms => terms.NoteType === 3).Content;

                        var tra_data = {
                            "Term":[
                                {
                                    "insCategory":"Travel",
                                    "NoteType":[4]
                                }
                            ]
                        }
                        postApi(apiConfig.CMSDomain , null, null, null, tra_data)
                            .then((response) => {
                                if (response.data.Code === 200) {
                                    termsMemberTravel.value = response.data.Data;
                                    //取得個條款內容
                                    policy3.value = termsMemberTravel.value.find(terms => terms.NoteType === 4).Content;

                                    tidyTerms();
                                } else {
                                    //跳出錯誤
                                    Swal.fire({
                                        title: "載入錯誤",
                                        showConfirmButton: false,
                                        showCloseButton: true,
                                        html: '<img src="error.svg"><p>條款載入錯誤</p>',
                                    });
                                }
                            })

                    } else {
                        //跳出錯誤
                        Swal.fire({
                            title: "載入錯誤",
                            showConfirmButton: false,
                            showCloseButton: true,
                            html: '<img src="error.svg"><p>條款載入錯誤</p>',
                        });
                    }
                })


        }
        const tidyTerms = () =>{
            const termsMemberApi = toRaw(termsMember.value);
            const termsMemberTravelApi = toRaw(termsMemberTravel.value)
            let allterms = termsMemberApi.concat(termsMemberTravelApi)
            termsMemberList = allterms.map((terms) =>{
                return {
                    id:terms.Id,
                    insures:terms.InsCategory,
                    cid:terms.NoteType,
                    publishDate: moment(terms.Date).format("YYYY-MM-DDTHH:mm:ss")
                }
            })
        }
        const getDevice = () => {
            let ua = navigator.userAgent ? navigator.userAgent.toLowerCase() : ""; // Add fallback for null
            let isWindowsPhone = /(?:Windows Phone)/.test(ua);
            let isSymbian = /(?:SymbianOS)/.test(ua) || isWindowsPhone;
            let isAndroid = /(?:Android)/.test(ua);
            let isTablet = /(ipad|tablet|(android(?!.*mobile))|(windows(?!.*phone)(.*touch))|kindle|playbook|silk|(puffin(?!.*(IP|AP|WP))))/.test(ua);
            let isPhone = /(?:iPhone)/.test(ua) && !isTablet;
            let isPc = !isPhone && !isAndroid && !isSymbian;

            if (isAndroid || isPhone) {
                device.value = "手機";
            } else if (isTablet) {
                device.value = "平板";
            } else if (isPc) {
                device.value = "電腦";
            } else {
                system.value = "Unknown";
            }
        };
        const getSystem = () =>{
            let agent = navigator.userAgent ? navigator.userAgent.toLowerCase() : "";
            let isMac = /macintosh | mac os x/i.test(navigator.userAgent);
            let isAndroid = /(Android)/i.test(navigator.userAgent);

            if(agent.indexOf("win32") >= 0 || agent.indexOf("wow32") >= 0){
                system.value="windows32"
            }
            else if(agent.indexOf("win64") >= 0 || agent.indexOf("wow64") >= 0){
                system.value="windows64"
            }
            else if (navigator.userAgent.indexOf('Mac OS X') !== -1) {
                system.value="iOS"
            }
            else if(isMac){
                system.value="iOS"
            }
            else if(isAndroid){
                system.value="Android"
            }
            else{
                system.value="Unknown"
            }


        }
        const getBrowser = () => {
            const userAgent = navigator.userAgent;
            let browser = "unkown";
            // Detect browser name
            browser = (/ucbrowser/i).test(userAgent) ? 'UCBrowser' : browser;
            browser = (/edg/i).test(userAgent) ? 'Edge' : browser;
            browser = (/googlebot/i).test(userAgent) ? 'GoogleBot' : browser;
            browser = (/chromium/i).test(userAgent) ? 'Chromium' : browser;
            browser = (/firefox|fxios/i).test(userAgent) && !(/seamonkey/i).test(userAgent) ? 'Firefox' : browser;
            browser = (/; msie|trident/i).test(userAgent) && !(/ucbrowser/i).test(userAgent) ? 'IE' : browser;
            browser = (/chrome|crios/i).test(userAgent) && !(/opr|opera|chromium|edg|ucbrowser|googlebot/i).test(userAgent) ? 'Chrome' : browser;
            browser = (/safari/i).test(userAgent) && !(/chromium|edg|ucbrowser|chrome|crios|opr|opera|fxios|firefox/i).test(userAgent) ? 'Safari' : browser;
            browser = (/opr|opera/i).test(userAgent) ? 'Opera' : browser;

            // detect browser version
            switch (browser) {
                case 'UCBrowser': return `${browser}`;
                case 'Edge': return `${browser}`;
                case 'GoogleBot': return `${browser}`;
                case 'Chromium': return `${browser}`;
                case 'Firefox': return `${browser}`;
                case 'Chrome': return `${browser}`;
                case 'Safari': return `${browser}`;
                case 'Opera': return `${browser}`;
                case 'IE':return `${browser}`;
                default: return `unknown/0.0.0.0`;
            }
        }
        const popupApplyAlert = ()=>{
            Swal.fire({
                title: "貼心提醒",
                showConfirmButton: true,
                showCloseButton: true,
                showCancelButton: true,
                cancelButtonText: '注意事項',
                confirmButtonText: "確定",
                reverseButtons: true,
                customClass: {container: "alert80vh"},
                html: '<img src="infomark.svg" class="infomark" ><p>親愛的客戶您好，您目前提供的投保資料於投保完成後，<span class="red">須親簽回傳要保書</span>。要保書經本公司審核通過且信用卡請款成功後，保單始可生效。</br>' +
                    '若有投保相關問題，請點擊下方按鈕查看投保注意事項，或於服務時間來電洽詢。感謝您的支持與配合。</p>',
            }).then((result) => {
                if (result.isConfirmed) {
                    isLoading.value = false;
                    router.push("/inform");
                } else if (result.dismiss === Swal.DismissReason.cancel) {
                    popupAttention();
                }
            });
        }
        const popupAttention = ()=>{
            var alertCon =
                '<div class="noticeCon alertApply attention">' +
                '<ol>' +
                '<li>要保人需為年滿18歲以上自然人。</li>' +
                '<li>投保時，要保人與被保險人均須在台、澎、金、馬境內。</li>' +
                '<li>身故受益人僅限配偶、直系血親(如父母、子女、祖父母)或法定繼承人。</li>' +
                '<li>依保險法規範，未滿15歲被保險人其喪葬費用保險金給付總和不得超過投保時遺產與贈與稅法第17條有關遺產稅喪葬費扣除額之半數，目前限額為69萬 ∘</li>' +
                '<li>因應主管機關規範，同一被保險人以網路投保旅平險並附加實支實付傷害醫療保險，重疊保險期間限投保1張。</li>' +
                '<li>同一保險期間（或保期有重疊），於本公司投保旅行綜合保險次數限1次。</li>' +
                '<li>保單型式：僅提供電子保單。</li>' +
                '<li>繳費須使用會員(要保人)之本人信用卡線上刷卡。(下列機構發行之信用卡不適用：澳盛銀行)</li>' +
                '<li>國外旅平險投保海外突發疾病險，須同時加購旅遊不便險，並依方案符合以下條件：</li>' +
                '<ul><li>不包含法定傳染病：被保險人未滿70歲、保險期間30天內(含)、出發日距離投保日30天內(含) 。</li>' +
                '<li>包含法定傳染病：被保險人年滿15歲至未滿70歲、保險期間30天內(含)、出發日距離投保日30天內(含)、旅遊國家為非申根國。</li></ul>' +
                '<li>國外旅平險欲申請申根憑證，旅遊國家請選擇申根國，且投保身故及失能1,200萬、傷害醫療120萬、海外突發疾病險150萬<span class="pinkText">(不包含法定傳染病)</span>、緊急救援費用保險150萬。投保成功後將收到電子保單及申根憑證。</li>' +
                '</ol>' +
                '<h3 class="blueTitle">網路投保</h3>' +
                '<ul class="caption">' +
                '<li class="captionTitle"><p>投保年齡(以旅遊出發時間為基準)</p><p>旅平險最高投保金額</p></li>' +
                '<li><p>未滿7歲</p><p>69萬元</p></li>' +
                '<li><p>滿7歲至未滿15歲</p><p>-</p></li>' +
                '<li><p>滿15歲至未滿18歲</p><p>-</p></li>' +
                '<li><p>滿18歲至未滿70歲</p><p>國內500萬元 / 國外1,200萬元</p></li>' +
                '<li><p>滿70歲至未滿80歲</p><p>300萬元</p></li>' +
                '<li><p>投保身份與人數</p><p>限本人或幫未滿7歲子女投保(最多四位)</p></li>' +
                '<li><p>投保時間</p><p>最晚須於出發時間1小時前完成投保</p></li>' +
                '<li><p>保單成立</p><p>線上完成繳費即成立保單</p></li>' +
                '</ul>' +
                '<h3 class="blueTitle">網路要保(回傳要保書)</h3>' +
                '<ul class="caption">' +
                '<li class="captionTitle"><p>投保年齡(以旅遊出發時間為基準)</p><p>旅平險最高投保金額</p></li>' +
                '<li><p>未滿7歲</p><p>69萬元</p></li>' +
                '<li><p>滿7歲至未滿15歲</p><p>69萬元</p></li>' +
                '<li><p>滿15歲至未滿18歲</p><p>國內500萬元 / 國外1,500萬元</p></li>' +
                '<li><p>滿18歲至未滿70歲</p><p>國內500萬元 / 國外1,500萬元</p></li>' +
                '<li><p>滿70歲至未滿80歲</p><p>300萬元</p></li>' +
                '<li><p>投保身份與人數</p><p>可為本人與家人們投保(最多四位)</p></li>' +
                '<li><p>投保時間</p><p>最晚須於出發日前3個工作日完成投保</p></li>' +
                '<li><p>保單成立</p><p>須於時效內簽名回傳要保書，並在通過審核後才算正式成立</p></li>' +
                '</ul>' +
                '<div class="attentionTxt pinkText">' +
                '<img class="attention" src="noticemark.svg">' +
                '<span>提醒您，欲投保的身份、年齡或投保額度需求不在上表中，請致電網路投保客服專線0800-366-168，或0800-050-119洽詢。</span>' +
                '</div>' +
                '</div>'
            Swal.fire({
                title: "旅平險線上投保前注意事項",
                showCloseButton: true,
                showConfirmButton: true,
                confirmButtonText: "返回",
                customClass: {
                    container: "attentionAlert alert80vh",
                },
                html: alertCon
            }).then((result) => {
                if (result.isConfirmed) {
                    popupApplyAlert();
                }
            });
        }


        //初始化載入
        pageStorage= JSON.parse(sessionStorage.getItem("pageStorage"));
        detailStorage = JSON.parse(sessionStorage.getItem("detailStorage"));
        jwtInfo = JSON.parse(localStorage.getItem("jwtInfo"));
        getRiskCountryList();
        getRiskJobList();
        getAddrCityList();
        if(termsCheck){
            getTermsMember();
        }
        onMounted(()=>{
            popUp();//公告系統
            gtm.pageViewEvent();//新增pageViewEvent
            checkLogin();
            loadDetailStorage();
            browserName.value = getBrowser();
            getDevice();
            getSystem();
        })

        watch(()=>applicantDataRiskCountry.value,(value)=>{
            applicantData.value.applicantRiskCountry = value;
            saveApplicantData();
        })

</script>
<style lang="scss">
#detail {
    .form {
        color: $textColor
    }

    #insertData {
        background: $blue-700;
        color: #fff;
        padding: 10px 15px;
        box-sizing: border-box;
        height: 40px;
        border-radius: 30px;
        margin-top: -8px;
        cursor: pointer;
        font-weight: 500;

        @media screen and (max-width: $small) {
            height: auto;
            font-size: 2.5vw;
            padding:10px 5px;
            img {
                width: 20px;
            }
        }

        &:hover {
            background:#0167c3;
            transition: all 200ms ease-in-out;
        }
    }

    #step::after {
        background-image: url("../assets/yellowBg.svg");
        background-size: 20%;
        background-repeat: no-repeat;
    }
    .attentionTxt {
        color: $textColor;
        margin: 10px 0;
        font-weight: 300;
        font-size:16px;
        img{
            width:24px;margin-right:5px;
            position: relative;
            top: 7px
        }
    }
    .policyCheck {
        opacity: 0.3;
        transition: opacity 100ms ease-in-out;
        color:$textColor;
        font-weight:500;
        @media screen and (max-width: $small) {font-size:16px;}
        &.active {
            opacity: 1;
        }
        .checkbox {
            margin: 10px 0;
            display: block;
            a {
                color: $blue-700;
            }
        }
    }
}
.swal2-container .swal2-cancel{
    width: 132px !important;
    padding: 10px 0;
}
</style>
